import { render, staticRenderFns } from "./BasicDetailsModal.vue?vue&type=template&id=ce653e5c"
import script from "./BasicDetailsModal.vue?vue&type=script&lang=js"
export * from "./BasicDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports